<!-- Session View -->

<h3>{{data?.title}}</h3>
<!-- <h4>{{data?.type.type.arabic}}</h4> -->
<p-divider align="left">
    <div class="inline-flex align-items-center">
        <i class="pi pi-map-marker ml-2 mr-2 course-icon-ui"></i>
        <b class="mx-3"> {{"the description"| translator}} </b>
    </div>
</p-divider>

<span [innerHTML]="data?.description"></span>

<p-divider align="left">
    <div class="inline-flex align-items-center">
        <i class="pi pi-calendar ml-2 mr-2 course-icon-ui"></i>
        <b class="mx-3"> {{"Duration"| translator}} </b>
    </div>
</p-divider>

<p><b>{{"starting date"| translator}} :</b> <span class="purple-capsule">{{data?.start_date | date}}</span></p>
<p><b>{{"Expiry date"| translator}}:</b> <span class="purple-capsule">{{data?.end_date | date}}</span></p>




<p-accordion [multiple]="true" [activeIndex]="[0]">
    <p-accordion [multiple]="true" [activeIndex]="[0]">
        <p-accordionTab *ngFor="let session of data?.session">
            <ng-template class="d-flex justify-content-between" pTemplate="header">
                <div class="d-flex justify-content-between">
                    <div class="flex align-items-center mx-1">
                        <i class="pi pi-bookmark-fill mx-1"></i>
                        <span class="vertical-align-middle">{{session.title}}</span>
                    </div>
                    <div class="mx-1">
                        <span class="vertical-align-middle">({{session.type}})</span>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="content">
                <p-divider align="left">
                    <div class="inline-flex align-items-center">
                        <i class="pi pi-bookmark-fill ml-2 mr-2 course-icon-ui"></i>
                        <b class="mx-3"> {{"Details of the time period"| translator}}</b>
                    </div>
                </p-divider>

                <p class="my-3"><span class="font-bold">{{"the date"| translator}} :</span><span class="purple-capsule">{{session.date | date}}</span></p>
                <p class="my-3"><span class="font-bold">{{"Starting time"| translator}} :</span><span class="purple-capsule">{{session.start_time}}</span></p>
                <p class="my-3"><span class="font-bold">{{"end time"| translator}} :</span><span class="purple-capsule">{{session.end_time }}</span></p>

                <!-- for course -->
                <section *ngIf="session.type == 'COURSE'">
                    <p-divider align="left">
                        <div class="inline-flex align-items-center">
                            <i class="pi pi-book ml-2 mr-2 course-icon-ui"></i>
                            <b class="mx-3"> {{"Course Details" | translator}} </b>
                        </div>
                    </p-divider>
                    <h3> <span class="font-bold"> {{"Course title :" | translator}}</span>
                        {{session.typeId.courseTitle}}</h3>
                    <h5><span class="font-bold"> {{"Course type :" | translator}}</span> {{session.typeId.courseType }}
                    </h5>
                    <p><span class="font-bold"> {{"The description :" | translator}}</span> {{session.typeId.description }}
                    </p>
                </section>
                <!-- End for course -->

                <!-- for Assessment -->
                <section *ngIf="session.type == 'ASSESSMENT'">
                    <p-divider align="left">
                        <div class="inline-flex align-items-center">
                            <i class="pi pi-book ml-2 mr-2 course-icon-ui"></i>
                            <b class="mx-3"> {{"Test details"| translator}} </b>
                        </div>
                    </p-divider>
                    <h3> {{session?.typeId?.assessmentTitle}}</h3>
                    <h5 class="my-4"><span class="font-bold">{{"Test type"| translator}} :</span>
                        <span class="purple-capsule">{{session.typeId.assessmentType }}</span></h5>
                    <p><span class="font-bold">{{"the description"| translator}} :</span> <span class="purple-capsule">{{session?.typeId?.description }}</span>
                    </p>
                </section>
                <!-- End for course -->

                <!-- for course -->
                <section *ngIf="session.type == 'SURVEY'">
                    <p-divider align="left">
                        <div class="inline-flex align-items-center">
                            <i class="pi pi-chart-line ml-2 mr-2 course-icon-ui"></i>
                            <b class="mx-3"> {{"Survey details"| translator}} </b>
                        </div>
                    </p-divider>
                    <h3> {{session?.typeId?.surveyTitle}}</h3>
                    <h5><span class="font-bold">{{"Poll type"| translator}} :</span><span class="purple-capsule">{{session?.typeId?.surveyType }}</span>
                    </h5>
                    <p><span class="font-bold">{{"the description"| translator}} :</span><span class="purple-capsule">{{session?.typeId?.description }}</span>
                    </p>
                </section>
                <!-- End for course -->

                <!-- for SESSION -->
                <section *ngIf="session.type == 'SESSION'">
                    <h5 class="mt-4"><b>{{"the coach"| translator}} :</b> <span class="purple-capsule">{{session.typeId.trainer.name}}</span></h5>
                    <div *ngIf="session.typeId.is_online; else elseBlock">
                        <p>{{"The workshop will be held online"| translator}}</p>
                        <p-divider align="left">
                            <div class="inline-flex align-items-center">
                                <i class="pi pi-link ml-2 mr-2 course-icon-ui"></i>
                                <b class="mx-3"> {{"Links"| translator}} </b>
                            </div>
                        </p-divider>
                        <!-- <p *ngIf="session.typeId.video_url" > <span class="font-bold">{{"video link"| translator}} :</span> {{session.typeId.video_url}}</p> -->
                        <p *ngIf="session?.typeId?.video_url"> <span class="font-bold">{{"video link"| translator}} :</span></p>
                        <video *ngIf="session.typeId.video_url" controls>
                            <source [src]="GlobalConstants.staticFilesURL+session.typeId.video_url" type="video/mp4">
                            {{"Your browser does not support the video tag." | translator}}
                        </video>
                        <p *ngIf="session.typeId.zoom_url"> <span class="font-bold">{{"Workshop link"| translator}} :</span>
                            {{session.typeId.zoom_url}}</p>
                    </div>
                    <ng-template #elseBlock>
                        <p-divider align="left">
                            <div class="inline-flex align-items-center">
                                <i class="pi pi-map-marker ml-2 mr-2 course-icon-ui"></i>
                                <b class="mx-3"> {{"the address"| translator}} </b>
                            </div>
                        </p-divider>
                        <p><span class="font-bold">{{"Headquarters address"| translator}} :</span><span class="purple-capsule">{{session.typeId.houseNumber}}</span>
                        </p>
                        <p><span class="font-bold"> {{"Building :" | translator}}</span><span class="purple-capsule">{{session.typeId.street}}</span></p>
                        <p><span class="font-bold">{{"City"| translator}} :</span><span class="purple-capsule">{{session.typeId.city}}</span></p>
                    </ng-template>
                </section>
                <!-- End for course -->

            </ng-template>

        </p-accordionTab>
    </p-accordion>
</p-accordion>
<!-- End Session View -->